import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

let PRELOADER_PLAYED = false;

export const Preloader = () => {
  const [done, setDone] = useState(PRELOADER_PLAYED);
  useEffect(() => {
    if (PRELOADER_PLAYED) {
      // already shown once this session — never replay, just hand off
      window.dispatchEvent(new Event("ag:intro-done"));
      return;
    }
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(
      () => {
        PRELOADER_PLAYED = true;
        setDone(true);
      },
      reduce ? 250 : 1500,
    );
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence
      onExitComplete={() => {
        window.dispatchEvent(new Event("ag:intro-done"));
      }}
    >
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--bg-0)]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          data-testid="preloader"
        >
          <div className="flex flex-col items-center gap-5">
            <motion.span
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="font-heading font-extrabold tracking-tight text-lg md:text-xl text-[var(--txt)]"
            >
              ACHIM GASTEIGER
              <span className="font-mono2 font-light text-[var(--txt-dim)] text-[10px] ml-2 tracking-[0.3em]">
                ARCHITEKTUR
              </span>
            </motion.span>
            <div className="h-px w-40 md:w-56 bg-[var(--line)] overflow-hidden">
              <motion.div
                className="h-full w-full bg-[var(--accent)]"
                initial={{ x: "-100%" }}
                animate={{ x: "0%" }}
                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
